export const ANNOTATION_SELECT_CATEGORY = 'ANNOTATION_SELECT_CATEGORY';
export const ANNOTATION_HOVER_CATEGORY = 'ANNOTATION_HOVER_CATEGORY';

export const BRUSH_SET_POSITION = 'BRUSH_SET_POSITION';
export const BRUSH_RESET = 'BRUSH_RESET';
export const HIGHLIGHTING_SET_RANGE = 'HIGHLIGHTING_SET_RANGE';
export const SET_DATA = 'SET_DATA';

export const METRIC_HIDE = 'METRIC_HIDE';
export const METRIC_SHOW = 'METRIC_SHOW';
export const SET_HIDDEN_METRICS = 'SET_HIDDEN_METRICS';

export const FORCE_RELOAD = 'FORCE_RELOAD';

export const RESET = 'RESET';

export const MOVE_TO_OWN_AXIS = 'MOVE_TO_OWN_AXIS';
export const MOVE_TO_GROUP_AXIS = 'MOVE_TO_GROUP_AXIS';
export const SET_OWN_AXIS_METRICS = 'SET_OWN_AXIS_METRICS';

const initialHighlighting = { start: null, end: null };
const initialAnnotations = {
  selectedCategory: null,
  hoveredCategory: null,
  selectedAnnotations: [],
};
const initialBrush = {
  startIndex: 0,
  endIndex: undefined,
  forceId: undefined,
};

export const defaultChartState = {
  forceReloadId: undefined,
  annotations: initialAnnotations,
  brush: initialBrush,
  hiddenMetrics: [],
  ownAxisMetrics: [],
  highlighting: initialHighlighting,
  maxIndex: 0,
};

function annotationReducer(state, action) {
  switch (action.type) {
    case ANNOTATION_SELECT_CATEGORY:
      const { category, annotations } = action.payload || initialAnnotations;
      return {
        ...state,
        selectedCategory: category,
        selectedAnnotations: annotations,
      };
    case ANNOTATION_HOVER_CATEGORY:
      return {
        ...state,
        hoveredCategory: action.payload,
      };
    default:
      return state;
  }
}

const getForceReloadId = () => `${Math.random()}_${+new Date()}`;

export function chartReducer(state, action) {
  switch (action.type) {
    case FORCE_RELOAD:
      return {
        ...state,
        forceReloadId: getForceReloadId(),
      };
    case ANNOTATION_SELECT_CATEGORY:
    case ANNOTATION_HOVER_CATEGORY:
      return {
        ...state,
        annotations: annotationReducer(state.annotations, action),
      };
    case BRUSH_SET_POSITION: {
      const payload = action.payload || initialBrush;
      return {
        ...state,
        brush: payload,
      };
    }

    case BRUSH_RESET: {
      return {
        ...state,
        forceReloadId: getForceReloadId(),
        brush: {
          ...initialBrush,
          forceId: state.brush.forceId,
        },
      };
    }
    case HIGHLIGHTING_SET_RANGE: {
      const payload = action.payload || initialHighlighting;
      const { start } = payload;

      let brush = state.brush;
      if (
        start !== null &&
        (brush.startIndex > start || start > brush.endIndex)
      ) {
        const range = brush.endIndex - brush.startIndex;
        const maxIndex = state.maxIndex;
        let startIndex = start;
        let endIndex = start + range;
        if (endIndex > maxIndex) {
          startIndex = maxIndex - range;
          endIndex = maxIndex;
        }

        brush = {
          ...brush,
          forceId: Math.random(),
          endIndex: endIndex,
          startIndex: startIndex,
        };
        // call handleBrushChange to force chart change startIndex and  endIndex
        // endIndex and startIndex props used only as default position
        action.__applyBrushPosition({
          endIndex: endIndex,
          startIndex: startIndex,
        });
      }

      return {
        ...state,
        brush: brush,
        highlighting: payload,
      };
    }

    case METRIC_HIDE:
      return {
        ...state,
        hiddenMetrics: [...state.hiddenMetrics, action.payload],
      };
    case METRIC_SHOW:
      return {
        ...state,
        hiddenMetrics: state.hiddenMetrics.filter((m) => m !== action.payload),
      };

    case SET_HIDDEN_METRICS:
      return {
        ...state,
        hiddenMetrics: action.payload,
      };

    case MOVE_TO_OWN_AXIS:
      return {
        ...state,
        ownAxisMetrics: [...state.ownAxisMetrics, action.payload],
      };
    case MOVE_TO_GROUP_AXIS:
      return {
        ...state,
        ownAxisMetrics: state.ownAxisMetrics.filter(
          (m) => m !== action.payload
        ),
      };

    case SET_OWN_AXIS_METRICS:
      return {
        ...state,
        ownAxisMetrics: action.payload,
      };

    case RESET:
      const { payload = defaultChartState } = action;
      return { ...payload, forceReloadId: getForceReloadId() };
    default:
      return state;
  }
}
